import { string } from "yup";

export const CaptchaString = string().required("");
